import type { LoaderFunctionArgs } from '@remix-run/cloudflare';
import { json } from '@remix-run/cloudflare';
import { Outlet } from '@remix-run/react';
import { useRouteData as _useRouteData } from '#app/hooks/useMatchesData.js';

const ROUTE_ID = 'routes/sessions/$courseId/attendance' as const;
export type RouteLoaderType = typeof loader;
export const useRouteData = () => _useRouteData<RouteLoaderType>(ROUTE_ID);
export type RouteLoaderData = ReturnType<typeof useRouteData>;

type Participant = {
  userId: string;
  userName: string;
  number: string | null;
  email: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  locked: boolean;
  active: boolean;
  inUse: true | undefined;
};

// Use this function to provide data for the route.
// - https://remix.run/api/conventions#loader
export const loader = async ({ context, params }: LoaderFunctionArgs) => {
  const { simcapture } = context;
  const participants: Participant[] = await simcapture.get(
    `/courses/${params.courseId}/participants`,
    {
      label: '/sessions/$courseId/participants',
    }
  );
  return json({ participants });
};

export default function SessionParticipantsLayout() {
  return <Outlet />;
}
